import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Input,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import { Field, FieldArray } from "formik";
import React from "react";
import FMUInputField from "../../components/shared/FormIkMUFormComponent/FMUInputField";
import AddIcon from "@material-ui/icons/AddCircle";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import InputMask from "react-input-mask";
import {
  generateQuickGuid,
  getPhoneMask,
} from "../../components/shared/helpers/helper";
import { Endpoint } from "../../api/base";
import { useToast } from "../../context/ToastContext";
import { tokens } from "../../theme/tokens";

const useStyles = makeStyles(() => ({
  paper: {
    width: "100%",
    maxWidth: "820px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.space[3],
    paddingTop: tokens.space[3],
    paddingBottom: tokens.space[4],
  },
  row: {
    display: "flex",
    gap: tokens.space[2],
    alignItems: "center",
    flexWrap: "wrap",
  },
  field: {
    flex: "1 1 140px",
    minWidth: "0px",
    height: "40px",
    backgroundColor: tokens.color.surface.default,
    border: `1px solid ${tokens.color.border.default}`,
    borderRadius: tokens.radius.sm,
    "& .MuiInputBase-input": {
      padding: `0px ${tokens.space[2]}`,
      fontSize: tokens.type.dense.size,
      color: tokens.color.text.primary,
    },
    "&.Mui-focused": { borderColor: tokens.color.focus.ring },
  },
  removeButton: {
    flex: "0 0 auto",
    color: tokens.color.text.secondary,
    "&:hover": { color: tokens.color.status.error },
  },
  addButton: {
    alignSelf: "flex-start",
    marginTop: tokens.space[2],
    textTransform: "none",
    fontWeight: 500,
    color: tokens.color.brand.primaryAction,
  },
}));

function ContactsDialog({ dialog, handleCloseDialog, values, setFieldValue }) {
  const classes = useStyles();
  const { showToast } = useToast();
  const handleClose = () => {
    let obj;
    let v = values;
    if (v.client_id === "") {
    } else {
      obj = {
        client_id: v.client_id,
        client_name: v.client_name,
        street_address: v.street_address_line2
          ? `${v.street_address} ${v.street_address_line2}`
          : `${v.street_address}`,
        city: v.city,
        zip_code: v.zip_code,
        abbreviation: v.abbreviation,
        hourly_rate: v.hourly_rate,
        database_search_rate: v.database_search_rate,
        local_investigator_rate: v.local_investigator_rate,
        contacts: v.contacts,
        state: v.state,
        local_investigator_mileage_rate: v.local_investigator_mileage_rate,
      };
      Endpoint.updateClient(obj)
        .then((res) => {
          showToast("Contact updated successfully.", "success");
          // window.location.reload()
        })
        .catch((err) => {
          showToast("Sorry something went wrong, please try again later.", "error");
        });
    }

    return handleCloseDialog();
  };
  return (
    <Dialog
      open={dialog}
      maxWidth={"lg"}
      classes={{ paper: classes.paper }}
      onClose={handleClose}
    >
      <DialogTitle>Client contacts</DialogTitle>
      <DialogContent>
        <FieldArray name={`contacts`}>
          {({ push, remove }) => (
            <div className={classes.content}>
              {values.contacts?.map((val, key) => {
                return (
                  <div className={classes.row} key={val.id || key}>
                    <Field
                      name={`contacts[${key}].first_name`}
                      type={"text"}
                      disableUnderline={true}
                      component={FMUInputField}
                      label={"First name"}
                      className={classes.field}
                    />
                    <Field
                      name={`contacts[${key}].last_name`}
                      type={"text"}
                      disableUnderline={true}
                      component={FMUInputField}
                      label={"Last name"}
                      className={classes.field}
                    />

                    <InputMask
                      mask={getPhoneMask()}
                      value={values.contacts[key].phone}
                      onChange={(e) => {
                        setFieldValue(`contacts[${key}].phone`, e.target.value);
                      }}
                    >
                      {(inputProps) => (
                        <Input
                          {...inputProps}
                          placeholder={"Phone number"}
                          type="text"
                          disableUnderline
                          className={classes.field}
                        />
                      )}
                    </InputMask>
                    <Field
                      name={`contacts[${key}].email`}
                      type={"text"}
                      disableUnderline={true}
                      component={FMUInputField}
                      label={"Email"}
                      className={classes.field}
                    />
                    <Tooltip title={"Remove this contact"}>
                      <IconButton
                        className={classes.removeButton}
                        size="small"
                        onClick={() => {
                          remove(key);
                        }}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                );
              })}
              <Button
                startIcon={<AddIcon />}
                onClick={() => {
                  push({
                    id: generateQuickGuid("client"),
                    first_name: "",
                    last_name: "",
                    phone: "",
                    email: "",
                  });
                }}
                className={classes.addButton}
              >
                Add contact
              </Button>
            </div>
          )}
        </FieldArray>
      </DialogContent>
    </Dialog>
  );
}

export default ContactsDialog;
